import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Paper, withStyles } from "@material-ui/core";

import { Tipografia } from "../../../../_common";

const styles = {
  textoEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  texto: { whiteSpace: "pre-line", paddingBottom: 5 },
  textoAnterior: { whiteSpace: "pre-line", paddingBottom: 8 },
  textoResponsavel: { whiteSpace: "pre-line", paddingBottom: 5 },
  divisor: { marginTop: "8px !important", marginBottom: "8px !important" },
  estiloCampo: { fontWeight: "bold" },
  estiloCard: { paddingBottom: 8 },
  linkJson: {
    margin: "auto 0px 8px auto",
    color: "#3d69a0 !important",
    cursor: "pointer",
  },
};

const TimelineItemLogCRM = ({ evento, index, isTimelineAtividades, classes }) => {
  const intl = useIntl();

  const retornoTratado = useMemo(() => JSON.parse(evento?.retorno), [evento.retorno]);

  return (
    <Paper className={classes.textoEvento} zDepth={1} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia
        tipo="notaLegendas"
        cor="darkSecondaryText"
        className={classes.textoResponsavel}
        id={`lblResponsavel-${index}`}
      >
        {evento.responsavel}
      </Tipografia>
      <Tipografia className={classes.texto}>
        {intl.formatMessage({ defaultMessage: "Falha ao enviar lead para o {tipoCrm}" }, { tipoCrm: evento.tipoCrm })}
      </Tipografia>
      {retornoTratado && (
        <>
          {retornoTratado.Entidade && (
            <Tipografia tipo="notaLegendas" className={classes.texto} cor="darkSecondaryText">
              {intl.formatMessage({ defaultMessage: "Entidade: {entidade}" }, { entidade: retornoTratado.Entidade })}
            </Tipografia>
          )}
          <Tipografia tipo="notaLegendas" className={classes.texto} cor="darkSecondaryText">
            {intl.formatMessage({ defaultMessage: "Erro: {erro}" }, { erro: retornoTratado.Erro })}
          </Tipografia>
        </>
      )}
    </Paper>
  );
};

TimelineItemLogCRM.propTypes = {
  evento: PropTypes.object,
  classes: PropTypes.object,
  index: PropTypes.number,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimelineItemLogCRM);
